<script setup lang="ts">
import { useFetchBlockSummary } from '~/api/service/block/summary/index.service'
import BlocksPageCharater from '~/components/@pages/blocks/BlocksPageCharater.vue'
import RouteButton from '~/components/button/RouteButton.vue'
import ListItemCard from '~/components/card/ListItemCard.vue'
import LoadingDashboardList from '~/components/loading/LoadingDashboardList.vue'
import BcLink from '~/ui/Link/BcLink.vue'
import BcProgress from '~/ui/Progress/BcProgress.vue'

const { data, isLoading } = useFetchBlockSummary(10)
</script>

<template>
  <div v-if="isLoading">
    <LoadingDashboardList />
  </div>
  <div v-else>
    <button
      class="list-button"
      @click="$router.push(routes.getBlockListPage())"
    >
      <div class="flex items-center gap-2">
        <RouteButton
          class="mb-2"
          label="Latest Block"
          :url="routes.getBlockListPage()"
        />
      </div>
    </button>
    <div class="relative">
      <BlocksPageCharater class="-right-4 -top-20 z-20" />
      <ListItemCard
        v-for="item in data"
        :key="item"
        class="list-item-card"
      >
        <NuxtLink
          :to="routes.getBlockDetailPageWithTab(item.BNO, blockDetailPageType.block)"
          class="hover:no-underline"
        >
          <div class="flex justify-between">
            <div class="flex">
              <div class="flex h-6 w-6 items-center justify-center">
                <FontAwesomeIcon
                  icon="cube"
                  size="xs"
                  class="text-primary"
                />
              </div>
              <div class="ml-2 inline-flex flex-col truncate">
                <BcLink
                  :content="item.blockNumber"
                  :to="routes.getBlockDetailPageWithTab(item.blockNumber, blockDetailPageType.block)"
                  class="truncate text-lg/[1.25rem] font-bold"
                />
                <span class="truncate text-base/[0.75rem] text-primary/40">
                  {{ item.AG }}
                </span>
              </div>
            </div>
            <div class="flex flex-col">
              <span class="truncate text-base/[1.125rem] text-primary/40">GAS USED</span>
              <div class="flex items-center gap-1">
                <span class="truncate text-base/[1.125rem] text-primary">{{ item.gasUsed }}</span>
                <Chip
                  class="truncate"
                  :value="`${item.gasUsedPercent} %`"
                />
              </div>
            </div>
          </div>
          <div class="my-2 flex">
            <BcProgress :value="item.gasUsedPercent" />
          </div>
          <div class="flex">
            <div class="basis-1/2">
              <div class="flex flex-col">
                <span class="text-base/[0.75rem] text-primary/40">TRANSACTIONS</span>
                <span class="mt-1 text-base/[0.75rem] text-primary">{{
                  item.trxCount
                }}</span>
              </div>
            </div>
            <div class="basis-1/2">
              <div class="flex flex-col">
                <span class="text-base/[0.75rem] text-primary/40">REWARD</span>
                <span class="mt-1 text-base/[0.75rem] text-primary">{{
                  item.blockReward
                }}</span>
              </div>
            </div>
          </div>
        </NuxtLink>
      </ListItemCard>
    </div>
    <button
      class="bottom-button"
      @click="$router.push(routes.getBlockListPage())"
    >
      <div class="flex items-center justify-center gap-2">
        <span class="text-base/[1.125rem] font-bold text-white">View all blocks</span>
        <FontAwesomeIcon
          icon="chevron-right"
          color="white"
          size="xs"
        />
      </div>
    </button>
  </div>
</template>

<style scoped lang="scss">
.list-button {
  @apply h-8 mb-2;
}

.list-button:hover {
  border-radius: 4px;
  @apply bg-primary/5
}

.list-item-card {
  @apply mt-2 h-[118px] p-4
}

.bottom-button {
  @apply mt-2 h-8 w-full rounded-lg bg-point-color hover:shadow-[0_16px_32px_0_rgba(92,143,250,0.2)];
}
</style>